const serializeRequirements = (reqs) =>
  Object.keys(reqs)
    .map((key) => (reqs[key] ? `${key}=${reqs[key]}` : undefined))
    .filter((a) => a)
    .join('&');
const journeyToRequirements = (item) => {
  const temperature_min = (item.temperature_ranges || []).length
    ? (item.temperature_ranges || []).reduce((m, { min }) => (min < m ? min : m), 100)
    : undefined;
  const temperature_max = (item.temperature_ranges || []).length
    ? (item.temperature_ranges || []).reduce((m, { max }) => (max > m ? max : m), -100)
    : undefined;

  return {
    route: (item.route && `${item.route.origin}-${item.route.destination}`) || undefined,
    pallets: item.max_equivalent_pallets,
    weight: item.max_weight,
    height: (item.item_height && item.item_height / 100) || undefined,
    needs_liftgate: (item.extras || []).indexOf('LIFTGATE') >= 0,
    needs_lateral_loading: (item.extras || []).indexOf('SIDE_LOAD') >= 0,
    needs_top_load: (item.extras || []).indexOf('TOP_LOAD') >= 0,
    temperature_chambers: (item.temperature_ranges || []).length,
    temperature_min,
    temperature_max,
  };
};

export { serializeRequirements, journeyToRequirements };
